import {Component, EventEmitter, Input, Output} from '@angular/core';

export type SmContextMenuSelectionStyle = 'none' | 'check' | 'radio';

export type SmContextMenuItemModel = {
  id: string;
  text?: string;
  textKey?: string;
  ariaLabel?: string;
  ariaLabelKey?: string;
  leadingText?: string;
  tone?: 'none' | 'viewer' | 'editor';
  iconName?: string;
  icon?: string;
  iconColor?: string;
  iconSrc?: string;
  iconAlt?: string;
  leadingIconVisible?: boolean;
  showTrailingCheck?: boolean;
  checked?: boolean;
  selected?: boolean;
  disabled?: boolean;
};

@Component({
  selector: 'sm-context-menu-item',
  templateUrl: './sm-context-menu-item.component.html',
  styleUrls: ['./sm-context-menu-item.component.scss'],
  standalone: false,
})
export class SmContextMenuItemComponent {
  @Input({required: true}) item!: SmContextMenuItemModel;
  @Input() selectionStyle: SmContextMenuSelectionStyle = 'none';

  @Output() itemClick = new EventEmitter<SmContextMenuItemModel>();

  handleClick(): void {
    if (this.item.disabled) {
      return;
    }

    this.itemClick.emit(this.item);
  }
}
